import React, { useState, useEffect } from "react";
import { G_API, G_DEF_COV } from "../constants/globalVar";
import axios from "axios";
import PlaceholderPageSlider from "./Placeholders/PlaceholderPageSlider";
import { FiArrowRightCircle } from "react-icons/fi";

const PageSlider = (props) => {
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const inputType = props.inputType;
    setLoading(true);

    var config = {
      method: "get",
      maxBodyLength: Infinity,
      url: G_API + "sliders/page/" + inputType,
    };

    axios(config)
      .then((response) => {
        let item = response.data.DATAS.slider;
        if (item == null) {
          item = {
            slider_img: null,
            status: true,
            title: props.inputType,
            sub_title:
              "We make free online courses, information sharing events, and volunteer work for community development.",
            action_label: "View More",
            action_url: "/about",
            type: "course",
            id: 4,
            __v: 0,
          };
        }
        setItem(item);
        setLoading(false);
      })
      .catch(function (error) {
        console.error(error);
      });
  }, [props.inputType]);

  const slideHeight = {
    "our team": "200px",
    "tuitionfee": "200px",
    admissions: "650px",
    default: "auto",
  };
  const hideValue = {
    "our team": "hide",
    "tuitionfee": "hide",
    "default": "",
  }
  const bgValue = {
    "admissions": "bg-success z-n1",
    "tuitionfee": "bg-success z-n1",
    "default": "",
  }

  const sliderImgDisplay = {
    "admissions": "none",
    "tuitionfee": "none",
    "default": "block",
  }

  const sliderStyle = {
    height: slideHeight[props.inputType] || slideHeight.default,
  };
  const sliderImageStyle = {
    objectFit: "cover",
    height: slideHeight[props.inputType] || slideHeight.default,
    maxHeight: "500px",
    display: sliderImgDisplay[props.inputType] || sliderImgDisplay.default,
  };

  const hideClass = hideValue[props.inputType] || hideValue.default;

  return (
    <div>
      {!loading && item ? (
        <div
          className={`carousel-item active ${ bgValue[props.inputType] || bgValue.default }`}
          style={sliderStyle}
        >
          {item.slider_img != null && item.slider_img.src ? (
            <img
              className="w-100 small-slider"
              src={item.slider_img.src}
              alt={item.title}
              style={sliderImageStyle}
            />
          ) : (
            <img
              className="w-100 small-slider"
              src={"/assets/images/" + G_DEF_COV}
              alt="Cover"
              style={sliderImageStyle}
            />
          )}

          <div className={`carousel-caption `} style={sliderStyle}>
            <div className="container-fluid">
              <div
                className={`row justify-content-center  ${
                  props.inputType === "admissions"
                    ? "text-start"
                    : "text-center"
                }`}
              >
                <div
                  className={`col-lg-7 col-md-10 col-sm-12 pt-0 ${hideClass}`}
                >
                  <h3
                    className="display-4 text-white mb-1 mt-2 pt-5 animated slideInDown"
                    style={{ fontSize: "2.3rem", textTransform: "capitalize" }}
                  >
                    {item.title}
                  </h3>
                  <p className="fs-5 text-white-50 mb-5 animated slideInDown">
                    {item.sub_title}
                  </p>
                  {props?.btn && <a className="btn btn-lg btn-primary rounded-5 animated slideInDown" href={props.btn.action_url}>
                      <span className="">{props.btn.action_label}</span>
                      <FiArrowRightCircle size="20px" className="ms-1"/>
                  </a>}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <PlaceholderPageSlider />
      )}
      {/* CSS for responsive behavior */}
      <style jsx="true">
        {`
          @media (max-width: 768px) {
            .carousel-item {
              height: ${props.inputType === "our team"
                ? "150px !important"
                : "auto !important"};
            }
            h3 {
              font-size: 1.5rem;
            }
            p {
              font-size: 1rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default PageSlider;
